export const SEND_MESSAGE_REQUEST = 'home/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'home/SEND_MESSAGE_SUCCESS';

export const CLOSE_CONTACT_MODAL = 'home/CLOSE_CONTACT_MODAL';
